<template>
    <section>
        <ds-modal
            :is-open="isFormsModalOpen"
            :title.sync="fullName"
            class="regular-modal"
            :size="modalSize"
            show-back
            @back="isFormsModalOpen = false"
        >
            <template>
                <div data-qa="display-fill-forms">
                    <ds-table-grid
                        :data="forms"
                        align="center"
                        data-qa="form-table-grid"
                        :click-row="openFormDetails"
                    >
                        <ds-table-grid-column
                            label="Form name"
                            width="90"
                        >
                            <template slot-scope="form">
                                <div>
                                    <span>
                                        {{ form.formName }}
                                    </span>
                                </div>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Date submitted"
                            width="110"
                        >
                            <template slot-scope="form">
                                <span>
                                    {{ dateFormatDate(form.submissionDate, 'MMM D, YYYY') }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Submitted by"
                            width="110"
                        >
                            <template slot-scope="form">
                                <span>
                                    {{ form.user }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Referring URL"
                            width="220"
                        >
                            <template slot-scope="form">
                                <span>
                                    {{ form.referringUrl }}
                                </span>
                            </template>
                        </ds-table-grid-column>
                    </ds-table-grid>
                </div>

                <contact-view-form ref="viewFormModal" :list-form-details="listFormDetails" :contact="contact" />
            </template>
        </ds-modal>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import ContactViewForm from './ContactViewForm';

export default {
    components: {
        ContactViewForm,
    },
    props: {
        contact: Object,
        id: String,
    },

    data() {
        return {
            forms: [],
            modalSize: 'fullscreen',
            listFormDetails: [],
            isFormsModalOpen: false,
        };
    },

    created() {
        this.getListForms();
    },

    computed: {
        fullName() {
            return `${this.contact?.firstName} ${this.contact?.lastName}`;
        },
    },

    methods: {
        async getListForms() {
            try {
                const response = await axios.get(`/app/webformSubmission/contactForms/${this.id}`);

                this.forms = response.data;
            } catch (error) {
                this.$error({ message: 'error while getting list of forms submission' });
            }
        },

        async openFormDetails(data) {
            try {
                const response = await axios.get(`/app/webformSubmission/getSubmissionDetails/${data.customFormWebResultId}`);

                this.listFormDetails = response.data;
                this.formType = 'view';
                this.$refs.viewFormModal.showModal(this.formType, 0);
            } catch (error) {
                this.$error({ message: 'error while get form submission details' });
            }
        },

        showAllFormsModal() {
            this.isFormsModalOpen = true;
        },

        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },
    },
};
</script>
